import { render, staticRenderFns } from "./DeactivatePicklrPopup.vue?vue&type=template&id=6bb5844e&scoped=true&"
import script from "./DeactivatePicklrPopup.vue?vue&type=script&lang=ts&"
export * from "./DeactivatePicklrPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeactivatePicklrPopup.vue?vue&type=style&index=0&id=6bb5844e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb5844e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb5844e')) {
      api.createRecord('6bb5844e', component.options)
    } else {
      api.reload('6bb5844e', component.options)
    }
    module.hot.accept("./DeactivatePicklrPopup.vue?vue&type=template&id=6bb5844e&scoped=true&", function () {
      api.rerender('6bb5844e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/DeactivatePicklrPopup.vue"
export default component.exports